import './style.css'
import * as THREE from 'three'
import { DragControls } from 'three/examples/jsm/controls/DragControls.js';


// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

//Texture

const cubeTextureLoader = new THREE.CubeTextureLoader();
const environment = cubeTextureLoader.load([
'Maps/Environment/px.png',
'Maps/Environment/nx.png',
'Maps/Environment/py.png',
'Maps/Environment/ny.png',
'Maps/Environment/pz.png',
'Maps/Environment/nz.png',
])



//size
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight 
}

window.addEventListener('resize', () =>
{
// Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

// Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
})
const ScrX=window.innerWidth/32;
const SrcY=window.innerHeight/24;

console.log(ScrX);
console.log(SrcY);

// Base camera
let fov = Math.PI/2;
let CameraZ = (sizes.height/1.0)/Math.tan(fov/2.0);
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1,1000,)
camera.position.set(ScrX/2, SrcY/2, 20);

//Mtr
// Define materials for the two states (normal and grouped) of objects
const blueMaterial = new THREE.MeshPhysicalMaterial({ color: 0x0077ff, transparent: true, opacity: 0.4,clearcoat:1,reflectivity:1,envMap:environment });
const greenMaterial = new THREE.MeshPhysicalMaterial({ color: 0x00ff77, transparent: true, opacity: 0.4,clearcoat:1,reflectivity:1,envMap:environment });
const yellowMaterial = new THREE.MeshPhysicalMaterial({ color: 0xffd700, transparent: true, opacity: 0.4,clearcoat:1,reflectivity:1,envMap:environment });
const groupedMaterial = new THREE.MeshPhysicalMaterial({ color: 0xff0000, transparent: true, opacity: 0.4,clearcoat:1,reflectivity:1,envMap:environment });

// Function to create a cuboid
function createCuboid(width, height, depth, material) {
    const geometry = new THREE.BoxGeometry(width, height, depth);
    return new THREE.Mesh(geometry, material);
  }
  
  // Create different shapes
  const shapes = [];
  
  // Create 12 vertical columns
  for (let i = 0; i < 12; i++) {
    const column = createCuboid(0.5, 3 + i * 2, 0.5, blueMaterial);
    column.position.set(Math.random() * ScrX , Math.random() * SrcY , Math.random() * 12 );
    column.receiveShadow=true;
    column.castShadow=true;
    shapes.push(column);
  }
  
  // Create 14 horizontal columns
  for (let i = 0; i < ScrX/2; i++) {
    const column = createCuboid(2 + i * 2, 0.5, 0.5, greenMaterial);
    column.position.set(Math.random() * ScrX , Math.random() * SrcY, Math.random() *12 - 8);
    column.receiveShadow=true;
    column.castShadow=true;
    shapes.push(column);
  }
  
  // Create 13 cubes
  for (let i = 0; i < ScrX/1.8; i++) {
    const cube = createCuboid(Math.random() * 2 + 1, Math.random() * 2 + 1, Math.random() * 2 + 1, yellowMaterial);
    cube.position.set(Math.random() * ScrX , Math.random() * SrcY, Math.random() * 12 - 8);
    cube.receiveShadow=true;
    cube.castShadow=true;
    shapes.push(cube);
  }
  
  // Create 15 cuboids
  for (let i = 0; i < ScrX/1.6; i++) {
    const cuboid = createCuboid(Math.random() * 2 + 1, Math.random() * 2 + 1, Math.random() * 2 + 1, blueMaterial);
    cuboid.position.set(Math.random() * ScrX , Math.random() * SrcY, Math.random() * 16 - 8);
    cuboid.receiveShadow=true;
    cuboid.castShadow=true;
    shapes.push(cuboid);
  }
  
  // Randomly intersect shapes
  for (const shapeA of shapes) {
    const numIntersections = Math.floor(Math.random() * 4) + 1;
    for (let i = 0; i < numIntersections; i++) {
      const shapeB = shapes[Math.floor(Math.random() * shapes.length)];
      if (shapeA !== shapeB) {
        shapeA.position.x += Math.random() * 0.2 - 0.1;
        shapeA.position.y += Math.random() * 0.2 - 0.1;
        shapeA.position.z += Math.random() * 0.2 - 0.1;
      }
    }
    scene.add(shapeA);
  }

//Render
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const dragControls = new DragControls(shapes, camera, renderer.domElement);

let selectedObject = null;

// Add an event listener to handle the drag interaction
dragControls.addEventListener('dragstart', (event) => {
  selectedObject = event.object;
});

dragControls.addEventListener('drag', (event) => {
  const draggedObject = event.object;

  // Check for intersections with other objects
  for (const otherObject of shapes) {
    if (draggedObject !== otherObject && areObjectsIntersecting(draggedObject, otherObject)) {
      // Change color and update the position of the intersected object
      otherObject.material = groupedMaterial;
      otherObject.position.copy(draggedObject.position);
    }
  }
});

dragControls.addEventListener('dragend', () => {
  selectedObject = null;
});

// Function to check if two objects are intersecting
function areObjectsIntersecting(objectA, objectB) {
  const boxA = new THREE.Box3().setFromObject(objectA);
  const boxB = new THREE.Box3().setFromObject(objectB);
  return boxA.intersectsBox(boxB);
}

// Add an event listener to handle mouse wheel events for zooming
document.addEventListener('wheel', (event) => {
  // Adjust the camera position based on the scroll direction
  const zoomSpeed = 0.1;
  camera.position.z += event.deltaY * zoomSpeed;

  // Limit the camera's zoom to a specific range if needed
  const minZoom = 5;
  const maxZoom = 50;
  camera.position.z = Math.max(minZoom, Math.min(maxZoom, camera.position.z));
});

// Add an event listener to handle double-click events on shapes
renderer.domElement.addEventListener('dblclick', (event) => {
  // Calculate mouse coordinates in normalized device coordinates (NDC)
  const mouse = new THREE.Vector2();
  mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

  // Raycast to find intersected objects
  const raycaster = new THREE.Raycaster();
  raycaster.setFromCamera(mouse, camera);
  const intersects = raycaster.intersectObjects(shapes);

  if (intersects.length > 0) {
    const clickedObject = intersects[0].object;

    // Reset the position of the clicked object to its initial position
    clickedObject.position.copy(clickedObject.initialPosition);

    // Reset material to its original state
    clickedObject.material = clickedObject.originalMaterial;
  }
});

//Lights
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
directionalLight.position.set(4, 6, 8);
scene.add(directionalLight);

const light = new THREE.PointLight(0xff04358, 1, 100);
light.position.set(3, 6, 9);
scene.add(light);

//shadows
directionalLight.castShadow = true;
directionalLight.shadow.camera.near =3500;
directionalLight.shadow.camera.far = 5000;

//animation
        const AniClock = new THREE.Clock();
        const Animate = () =>
        {
            // const elapse = AniClock.getElapsedTime();
            directionalLight.position.copy(camera.position);
            directionalLight.lookAt(scene.position);
            shapes.forEach(shape => {
                if (shape.rotationSpeed) {
                  shape.rotation.x += shape.rotationSpeed.x;
                  shape.rotation.y += shape.rotationSpeed.y;
                  shape.rotation.z += shape.rotationSpeed.z;
                }
              });


            renderer.render(scene, camera);
            window.requestAnimationFrame(Animate);
        }

        // Set rotation speeds for rotating shapes
shapes.forEach(shape => {
    if (!shape.rotationSpeed) {
      shape.rotationSpeed = new THREE.Vector3(Math.random() * 0.01, Math.random() * 0.01, Math.random() * 0.01);
    }
  });
  
  // Save the initial position and material of each shape
  shapes.forEach(shape => {
    shape.initialPosition = shape.position.clone();
    shape.originalMaterial = shape.material.clone();
  });


        Animate();

